import { Body } from '@assembly-js/design-system';
import React from 'react';

import { ModalWrapper, ModalWrapperProps } from 'src/legacy/components/Modals';
import {
  ChoosePaymentMethod,
  ChoosePaymentMethodProps,
  PaymentMethodType,
} from 'src/routes/payments/payments-methods/components/ChoosePaymentMethod';
import { PaymentOptions } from 'src/services/api/invoicesApi';

export type ChoosePaymentMethodOptions = Omit<
  ChoosePaymentMethodProps,
  'onPaymentMethodSelected'
>;

interface AddPaymentMethodModalProps {
  modalProps: ModalWrapperProps;
  paymentOptions: PaymentOptions;
  onPaymentMethodSelected: (paymentMethod: PaymentMethodType) => void;
  amountDue: number;
  currency: string;
}

export const AddPaymentMethodModal: React.FC<AddPaymentMethodModalProps> = ({
  modalProps,
  paymentOptions,
  onPaymentMethodSelected,
  amountDue,
  currency,
}) => (
  <ModalWrapper
    title="Connect payment method"
    hideActions
    width={500}
    {...modalProps}
    disableEnforceFocus
  >
    <div>
      <Body size="sm" className="text-secondary leading-5">
        Select a payment method type you want to add.
      </Body>
      <ChoosePaymentMethod
        paymentOptions={paymentOptions}
        onPaymentMethodSelected={onPaymentMethodSelected}
        amountDue={amountDue}
        currency={currency}
      />
    </div>
  </ModalWrapper>
);
